module.exports = __webpack_public_path__ + "static/sm-mailgun-alternatives-og-1cae296ab51abe04ab32e4d90d25a586.jpg";